/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumFollowupAction = "alertStaff" | "arriveAppointment" | "assignChat" | "cancelAppointment" | "cancelReferral" | "closeChat" | "confirmAppointment" | "createPatientInIntegrator" | "createReferral" | "executeJavascript" | "httpsWebhook" | "internalChat" | "joinWaitingRoom" | "joinWaitlist" | "leaveWaitlist" | "openChat" | "sendMessage" | "sendPhysicalMail" | "startBot" | "%future added value";
export type EnumFollowupActionAtAnchor = "objectDate" | "operation" | "%future added value";
export type EnumFollowupActionAtUnit = "days" | "hours" | "minutes" | "seconds" | "%future added value";
export type EnumFollowupBot = "botFollowup" | "botJenna" | "botReferral" | "%future added value";
export type EnumFollowupFiltersComparision = "cron" | "eq" | "gt" | "gte" | "js" | "lt" | "lte" | "ne" | "regex" | "%future added value";
export type EnumFollowupForceCommunicationAs = "email" | "none" | "sms" | "voice" | "whatsapp" | "%future added value";
export type EnumFollowupModel = "activity" | "all" | "appointment" | "appointmentType" | "chatActivity" | "diagnosis" | "facility" | "feedbackResponse" | "fileUpload" | "group" | "hl7Message" | "insurance" | "intent" | "invoke" | "message" | "messageTemplate" | "offer" | "outboundNumber" | "patient" | "patientForm" | "patientFormTemplate" | "patientMessageTemplate" | "procedure" | "provider" | "recall" | "referral" | "reminder" | "schedule" | "telehealth" | "user" | "waitingRoomPatient" | "waitlist" | "%future added value";
export type EnumFollowupOperation = "created" | "deleted" | "updated" | "%future added value";
export type FilterFindManyFollowupInput = {
    user?: string | null | undefined;
    title?: string | null | undefined;
    model?: EnumFollowupModel | null | undefined;
    operation?: EnumFollowupOperation | null | undefined;
    filters?: Array<FollowupFiltersInput | null> | null | undefined;
    action?: EnumFollowupAction | null | undefined;
    actionAt?: number | null | undefined;
    actionAtUnit?: EnumFollowupActionAtUnit | null | undefined;
    actionAtAnchor?: EnumFollowupActionAtAnchor | null | undefined;
    anchorAtOperationPastEventsTolerance?: number | null | undefined;
    template?: string | null | undefined;
    type?: string | null | undefined;
    group?: string | null | undefined;
    secure?: boolean | null | undefined;
    forceCommunicationAs?: EnumFollowupForceCommunicationAs | null | undefined;
    delay?: number | null | undefined;
    stats?: FollowupStatsInput | null | undefined;
    enabled?: boolean | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    deleted?: number | null | undefined;
    rebuildDateRange?: unknown | null | undefined;
    sendMessageSkipDeliveryRules?: boolean | null | undefined;
    sendMessageSkipBlackoutRules?: boolean | null | undefined;
    sendMessageForceTimeHour?: number | null | undefined;
    sendMessageForceTimeMinute?: number | null | undefined;
    sendMessageAutomaticallyHandleIrregularIntent?: boolean | null | undefined;
    webhook?: string | null | undefined;
    webhookHmacSecret?: string | null | undefined;
    webhookHeaders?: Array<FollowupWebhookHeadersInput | null> | null | undefined;
    bot?: EnumFollowupBot | null | undefined;
    joinWaitingRoomRoom?: string | null | undefined;
    openChatFacility?: string | null | undefined;
    sendPhysicalMailLobApiKey?: string | null | undefined;
    sendPhysicalMailFromAddressOverride?: string | null | undefined;
    sendPhysicalMailFrontTemplate?: string | null | undefined;
    sendMessageDayOfWeekRule?: FollowupSendMessageDayOfWeekRuleInput | null | undefined;
    executeJavaScript?: string | null | undefined;
    sendMessageShouldSkipReminderDeduping?: boolean | null | undefined;
    configuration?: FollowupConfigurationInput | null | undefined;
    _id?: string | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterFindManyFollowupInput | null | undefined;
    OR?: Array<FilterFindManyFollowupInput> | null | undefined;
    AND?: Array<FilterFindManyFollowupInput> | null | undefined;
};
export type FollowupFiltersInput = {
    field?: string | null | undefined;
    value?: string | null | undefined;
    comparision?: EnumFollowupFiltersComparision | null | undefined;
    options?: string | null | undefined;
};
export type FollowupStatsInput = {
    counters?: FollowupStatsCountersInput | null | undefined;
    _id?: string | null | undefined;
};
export type FollowupStatsCountersInput = {
    actionMatched?: number | null | undefined;
    _id?: string | null | undefined;
};
export type FollowupWebhookHeadersInput = {
    header?: string | null | undefined;
    value?: string | null | undefined;
    _id?: string | null | undefined;
};
export type FollowupSendMessageDayOfWeekRuleInput = {
    startAt?: number | null | undefined;
    endAt?: number | null | undefined;
    daysOfWeek?: Array<unknown | null> | null | undefined;
    enabled?: boolean | null | undefined;
    _id?: string | null | undefined;
};
export type FollowupConfigurationInput = {
    alertStaff?: FollowupConfigurationAlertStaffInput | null | undefined;
    assignChat?: FollowupConfigurationAssignChatInput | null | undefined;
};
export type FollowupConfigurationAlertStaffInput = {
    users?: Array<string | null> | null | undefined;
    facilities?: Array<string | null> | null | undefined;
};
export type FollowupConfigurationAssignChatInput = {
    ref?: string | null | undefined;
    refId?: string | null | undefined;
};
export type OperatorsFilterFindManyFollowupInput = {
    user?: UserOperatorsFilterFindManyFollowupInput | null | undefined;
    title?: TitleOperatorsFilterFindManyFollowupInput | null | undefined;
    model?: ModelOperatorsFilterFindManyFollowupInput | null | undefined;
    operation?: OperationOperatorsFilterFindManyFollowupInput | null | undefined;
    filters?: FiltersOperatorsFilterFindManyFollowupInput | null | undefined;
    action?: ActionOperatorsFilterFindManyFollowupInput | null | undefined;
    actionAt?: ActionAtOperatorsFilterFindManyFollowupInput | null | undefined;
    actionAtUnit?: ActionAtUnitOperatorsFilterFindManyFollowupInput | null | undefined;
    actionAtAnchor?: ActionAtAnchorOperatorsFilterFindManyFollowupInput | null | undefined;
    anchorAtOperationPastEventsTolerance?: AnchorAtOperationPastEventsToleranceOperatorsFilterFindManyFollowupInput | null | undefined;
    template?: TemplateOperatorsFilterFindManyFollowupInput | null | undefined;
    type?: TypeOperatorsFilterFindManyFollowupInput | null | undefined;
    group?: GroupOperatorsFilterFindManyFollowupInput | null | undefined;
    secure?: SecureOperatorsFilterFindManyFollowupInput | null | undefined;
    forceCommunicationAs?: ForceCommunicationAsOperatorsFilterFindManyFollowupInput | null | undefined;
    delay?: DelayOperatorsFilterFindManyFollowupInput | null | undefined;
    stats?: StatsOperatorsFilterFindManyFollowupInput | null | undefined;
    enabled?: EnabledOperatorsFilterFindManyFollowupInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterFindManyFollowupInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterFindManyFollowupInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterFindManyFollowupInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterFindManyFollowupInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterFindManyFollowupInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterFindManyFollowupInput | null | undefined;
    deleted?: DeletedOperatorsFilterFindManyFollowupInput | null | undefined;
    rebuildDateRange?: RebuildDateRangeOperatorsFilterFindManyFollowupInput | null | undefined;
    sendMessageSkipDeliveryRules?: SendMessageSkipDeliveryRulesOperatorsFilterFindManyFollowupInput | null | undefined;
    sendMessageSkipBlackoutRules?: SendMessageSkipBlackoutRulesOperatorsFilterFindManyFollowupInput | null | undefined;
    sendMessageForceTimeHour?: SendMessageForceTimeHourOperatorsFilterFindManyFollowupInput | null | undefined;
    sendMessageForceTimeMinute?: SendMessageForceTimeMinuteOperatorsFilterFindManyFollowupInput | null | undefined;
    sendMessageAutomaticallyHandleIrregularIntent?: SendMessageAutomaticallyHandleIrregularIntentOperatorsFilterFindManyFollowupInput | null | undefined;
    webhook?: WebhookOperatorsFilterFindManyFollowupInput | null | undefined;
    webhookHmacSecret?: WebhookHmacSecretOperatorsFilterFindManyFollowupInput | null | undefined;
    webhookHeaders?: WebhookHeadersOperatorsFilterFindManyFollowupInput | null | undefined;
    bot?: BotOperatorsFilterFindManyFollowupInput | null | undefined;
    joinWaitingRoomRoom?: JoinWaitingRoomRoomOperatorsFilterFindManyFollowupInput | null | undefined;
    openChatFacility?: OpenChatFacilityOperatorsFilterFindManyFollowupInput | null | undefined;
    sendPhysicalMailLobApiKey?: SendPhysicalMailLobApiKeyOperatorsFilterFindManyFollowupInput | null | undefined;
    sendPhysicalMailFromAddressOverride?: SendPhysicalMailFromAddressOverrideOperatorsFilterFindManyFollowupInput | null | undefined;
    sendPhysicalMailFrontTemplate?: SendPhysicalMailFrontTemplateOperatorsFilterFindManyFollowupInput | null | undefined;
    sendMessageDayOfWeekRule?: SendMessageDayOfWeekRuleOperatorsFilterFindManyFollowupInput | null | undefined;
    executeJavaScript?: ExecuteJavaScriptOperatorsFilterFindManyFollowupInput | null | undefined;
    sendMessageShouldSkipReminderDeduping?: SendMessageShouldSkipReminderDedupingOperatorsFilterFindManyFollowupInput | null | undefined;
    configuration?: ConfigurationOperatorsFilterFindManyFollowupInput | null | undefined;
    _id?: _idOperatorsFilterFindManyFollowupInput | null | undefined;
};
export type UserOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type TitleOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ModelOperatorsFilterFindManyFollowupInput = {
    gt?: EnumFollowupModel | null | undefined;
    gte?: EnumFollowupModel | null | undefined;
    lt?: EnumFollowupModel | null | undefined;
    lte?: EnumFollowupModel | null | undefined;
    ne?: EnumFollowupModel | null | undefined;
    in?: Array<EnumFollowupModel | null> | null | undefined;
    nin?: Array<EnumFollowupModel | null> | null | undefined;
    regex?: EnumFollowupModel | null | undefined;
};
export type OperationOperatorsFilterFindManyFollowupInput = {
    gt?: EnumFollowupOperation | null | undefined;
    gte?: EnumFollowupOperation | null | undefined;
    lt?: EnumFollowupOperation | null | undefined;
    lte?: EnumFollowupOperation | null | undefined;
    ne?: EnumFollowupOperation | null | undefined;
    in?: Array<EnumFollowupOperation | null> | null | undefined;
    nin?: Array<EnumFollowupOperation | null> | null | undefined;
    regex?: EnumFollowupOperation | null | undefined;
};
export type FiltersOperatorsFilterFindManyFollowupInput = {
    gt?: FollowupFiltersInput | null | undefined;
    gte?: FollowupFiltersInput | null | undefined;
    lt?: FollowupFiltersInput | null | undefined;
    lte?: FollowupFiltersInput | null | undefined;
    ne?: FollowupFiltersInput | null | undefined;
    in?: Array<FollowupFiltersInput | null> | null | undefined;
    nin?: Array<FollowupFiltersInput | null> | null | undefined;
    regex?: FollowupFiltersInput | null | undefined;
};
export type ActionOperatorsFilterFindManyFollowupInput = {
    gt?: EnumFollowupAction | null | undefined;
    gte?: EnumFollowupAction | null | undefined;
    lt?: EnumFollowupAction | null | undefined;
    lte?: EnumFollowupAction | null | undefined;
    ne?: EnumFollowupAction | null | undefined;
    in?: Array<EnumFollowupAction | null> | null | undefined;
    nin?: Array<EnumFollowupAction | null> | null | undefined;
    regex?: EnumFollowupAction | null | undefined;
};
export type ActionAtOperatorsFilterFindManyFollowupInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type ActionAtUnitOperatorsFilterFindManyFollowupInput = {
    gt?: EnumFollowupActionAtUnit | null | undefined;
    gte?: EnumFollowupActionAtUnit | null | undefined;
    lt?: EnumFollowupActionAtUnit | null | undefined;
    lte?: EnumFollowupActionAtUnit | null | undefined;
    ne?: EnumFollowupActionAtUnit | null | undefined;
    in?: Array<EnumFollowupActionAtUnit | null> | null | undefined;
    nin?: Array<EnumFollowupActionAtUnit | null> | null | undefined;
    regex?: EnumFollowupActionAtUnit | null | undefined;
};
export type ActionAtAnchorOperatorsFilterFindManyFollowupInput = {
    gt?: EnumFollowupActionAtAnchor | null | undefined;
    gte?: EnumFollowupActionAtAnchor | null | undefined;
    lt?: EnumFollowupActionAtAnchor | null | undefined;
    lte?: EnumFollowupActionAtAnchor | null | undefined;
    ne?: EnumFollowupActionAtAnchor | null | undefined;
    in?: Array<EnumFollowupActionAtAnchor | null> | null | undefined;
    nin?: Array<EnumFollowupActionAtAnchor | null> | null | undefined;
    regex?: EnumFollowupActionAtAnchor | null | undefined;
};
export type AnchorAtOperationPastEventsToleranceOperatorsFilterFindManyFollowupInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type TemplateOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type TypeOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type GroupOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SecureOperatorsFilterFindManyFollowupInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type ForceCommunicationAsOperatorsFilterFindManyFollowupInput = {
    gt?: EnumFollowupForceCommunicationAs | null | undefined;
    gte?: EnumFollowupForceCommunicationAs | null | undefined;
    lt?: EnumFollowupForceCommunicationAs | null | undefined;
    lte?: EnumFollowupForceCommunicationAs | null | undefined;
    ne?: EnumFollowupForceCommunicationAs | null | undefined;
    in?: Array<EnumFollowupForceCommunicationAs | null> | null | undefined;
    nin?: Array<EnumFollowupForceCommunicationAs | null> | null | undefined;
    regex?: EnumFollowupForceCommunicationAs | null | undefined;
};
export type DelayOperatorsFilterFindManyFollowupInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type StatsOperatorsFilterFindManyFollowupInput = {
    gt?: FollowupStatsInput | null | undefined;
    gte?: FollowupStatsInput | null | undefined;
    lt?: FollowupStatsInput | null | undefined;
    lte?: FollowupStatsInput | null | undefined;
    ne?: FollowupStatsInput | null | undefined;
    in?: Array<FollowupStatsInput | null> | null | undefined;
    nin?: Array<FollowupStatsInput | null> | null | undefined;
    regex?: FollowupStatsInput | null | undefined;
};
export type EnabledOperatorsFilterFindManyFollowupInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type CreatedAtOperatorsFilterFindManyFollowupInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterFindManyFollowupInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type CreatedByOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterFindManyFollowupInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type DeletedOperatorsFilterFindManyFollowupInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type RebuildDateRangeOperatorsFilterFindManyFollowupInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type SendMessageSkipDeliveryRulesOperatorsFilterFindManyFollowupInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type SendMessageSkipBlackoutRulesOperatorsFilterFindManyFollowupInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type SendMessageForceTimeHourOperatorsFilterFindManyFollowupInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type SendMessageForceTimeMinuteOperatorsFilterFindManyFollowupInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type SendMessageAutomaticallyHandleIrregularIntentOperatorsFilterFindManyFollowupInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type WebhookOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type WebhookHmacSecretOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type WebhookHeadersOperatorsFilterFindManyFollowupInput = {
    gt?: FollowupWebhookHeadersInput | null | undefined;
    gte?: FollowupWebhookHeadersInput | null | undefined;
    lt?: FollowupWebhookHeadersInput | null | undefined;
    lte?: FollowupWebhookHeadersInput | null | undefined;
    ne?: FollowupWebhookHeadersInput | null | undefined;
    in?: Array<FollowupWebhookHeadersInput | null> | null | undefined;
    nin?: Array<FollowupWebhookHeadersInput | null> | null | undefined;
    regex?: FollowupWebhookHeadersInput | null | undefined;
};
export type BotOperatorsFilterFindManyFollowupInput = {
    gt?: EnumFollowupBot | null | undefined;
    gte?: EnumFollowupBot | null | undefined;
    lt?: EnumFollowupBot | null | undefined;
    lte?: EnumFollowupBot | null | undefined;
    ne?: EnumFollowupBot | null | undefined;
    in?: Array<EnumFollowupBot | null> | null | undefined;
    nin?: Array<EnumFollowupBot | null> | null | undefined;
    regex?: EnumFollowupBot | null | undefined;
};
export type JoinWaitingRoomRoomOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type OpenChatFacilityOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SendPhysicalMailLobApiKeyOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SendPhysicalMailFromAddressOverrideOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SendPhysicalMailFrontTemplateOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SendMessageDayOfWeekRuleOperatorsFilterFindManyFollowupInput = {
    gt?: FollowupSendMessageDayOfWeekRuleInput | null | undefined;
    gte?: FollowupSendMessageDayOfWeekRuleInput | null | undefined;
    lt?: FollowupSendMessageDayOfWeekRuleInput | null | undefined;
    lte?: FollowupSendMessageDayOfWeekRuleInput | null | undefined;
    ne?: FollowupSendMessageDayOfWeekRuleInput | null | undefined;
    in?: Array<FollowupSendMessageDayOfWeekRuleInput | null> | null | undefined;
    nin?: Array<FollowupSendMessageDayOfWeekRuleInput | null> | null | undefined;
    regex?: FollowupSendMessageDayOfWeekRuleInput | null | undefined;
};
export type ExecuteJavaScriptOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SendMessageShouldSkipReminderDedupingOperatorsFilterFindManyFollowupInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type ConfigurationOperatorsFilterFindManyFollowupInput = {
    gt?: FollowupConfigurationInput | null | undefined;
    gte?: FollowupConfigurationInput | null | undefined;
    lt?: FollowupConfigurationInput | null | undefined;
    lte?: FollowupConfigurationInput | null | undefined;
    ne?: FollowupConfigurationInput | null | undefined;
    in?: Array<FollowupConfigurationInput | null> | null | undefined;
    nin?: Array<FollowupConfigurationInput | null> | null | undefined;
    regex?: FollowupConfigurationInput | null | undefined;
};
export type _idOperatorsFilterFindManyFollowupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FilterFollowupList_refetchableVariables = {
    count?: number | null | undefined;
    cursor?: string | null | undefined;
    filter?: FilterFindManyFollowupInput | null | undefined;
};
export type FilterFollowupList_refetchableResponse = {
    readonly " $fragmentRefs": FragmentRefs<"FilterFollowupList_Query">;
};
export type FilterFollowupList_refetchable = {
    readonly response: FilterFollowupList_refetchableResponse;
    readonly variables: FilterFollowupList_refetchableVariables;
};



/*
query FilterFollowupList_refetchable(
  $count: Int = 25
  $cursor: String
  $filter: FilterFindManyFollowupInput
) {
  ...FilterFollowupList_Query_1G22uz
}

fragment FilterFollowupList_Query_1G22uz on Query {
  followupConnection(first: $count, after: $cursor, filter: $filter, sort: TITLE_ASC) {
    edges {
      node {
        _id
        title
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 25,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "TITLE_ASC"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterFollowupList_refetchable",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          }
        ],
        "kind": "FragmentSpread",
        "name": "FilterFollowupList_Query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterFollowupList_refetchable",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FollowupConnection",
        "kind": "LinkedField",
        "name": "followupConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FollowupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Followup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filter",
          "sort"
        ],
        "handle": "connection",
        "key": "FilterFollowupList_followupConnection",
        "kind": "LinkedHandle",
        "name": "followupConnection"
      }
    ]
  },
  "params": {
    "cacheID": "b90030a0dc578d7b149c288070f73c89",
    "id": null,
    "metadata": {},
    "name": "FilterFollowupList_refetchable",
    "operationKind": "query",
    "text": "query FilterFollowupList_refetchable(\n  $count: Int = 25\n  $cursor: String\n  $filter: FilterFindManyFollowupInput\n) {\n  ...FilterFollowupList_Query_1G22uz\n}\n\nfragment FilterFollowupList_Query_1G22uz on Query {\n  followupConnection(first: $count, after: $cursor, filter: $filter, sort: TITLE_ASC) {\n    edges {\n      node {\n        _id\n        title\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f857ae726cb99cd989a47f83b3218f99';
export default node;
